import {
    SET_SECONDARY_BAR_TYPE,
    SET_SECONDARY_BAR_TYPE_3,
    TOGGLE_SECONDARY_BAR,
    TOGGLE_SECONDARY_BAR_3,
} from "app/action_types/secondary_bar_action_types";
import type { SecondarySideBarType3 } from "app/components/sidebar3/types";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";

export const toggleSecondaryBar = (isOpened: boolean) => {
    return {
        type: TOGGLE_SECONDARY_BAR,
        isSecondaryBarOpen: isOpened,
    };
};

export const setSecondaryBarType = (secondaryBarType: SecondaryBarType) => {
    return {
        type: SET_SECONDARY_BAR_TYPE,
        secondaryBarType,
    };
};

// Actions for sidebar 3
export const toggleSecondaryBar3 = (isOpened: boolean) => {
    return {
        type: TOGGLE_SECONDARY_BAR_3,
        isSecondaryBar3Open: isOpened,
    };
};

export const setSecondaryBarType3 = (secondaryBarType3: SecondarySideBarType3 | "None") => {
    return {
        type: SET_SECONDARY_BAR_TYPE_3,
        secondaryBarType3,
    };
};
